<template>
  <div>
    <pageTable
      ref="table"
      :tableTitle="tableColumn"
      :searchData="searchData"
      tableApi="admin/user/getAdminOperationLog"
      :showSearchForm="false"
    >
      <template v-slot:searchFormItem>
        <FormItem label="">
          <Input v-model="searchData.operator" placeholder="请输入操作人员" clearable style="width: 200px"></Input>
        </FormItem>
        <FormItem label="">
          <Select v-model="searchData.type" placeholder="操作类型" clearable style="width: 200px">
            <Option value="">全部</Option>
            <Option value="addCompanyStationFileTask">批量设置车队站点价格</Option>
            <Option value="rechargeCompany">车队充值</Option>
            <Option value="editStationPrice">修改站点价格</Option>
            <Option value="refund">退款操作</Option>
            <Option value="addNdrcPriceTask">挂牌价设置</Option>
            <Option value="editCompanyStationPrice">车队价格修改</Option>
            <Option value="partnerApplyCompanyStationPrice">合伙人调价申请</Option>
            <Option value="partnerAuditCompanyStationPrice">运营审核调价申请</Option>
          </Select>
        </FormItem>
        <FormItem label="">
          <DatePicker 
            v-model="searchData.timeRange" 
            type="datetimerange" 
            @on-change="timeChange" 
            placeholder="请选择时间范围"
            style="width: 320px"
          ></DatePicker>
        </FormItem>
        <FormItem style="margin-right: 0;">
          <Button type="primary" icon="ios-search" @click="handleSearch">搜索</Button>
          <Button style="margin-left: 10px;" @click="handleReset">重置</Button>
        </FormItem>
      </template>
    </pageTable>
  </div>
</template>

<script>
import pageTable from "@/components/table/pageTable";

export default {
  name: "operationLog",
  components: {
    pageTable
  },
  data() {
    return {
      searchData: {
        operator: '',
        type: '',
        timeRange: []
      },
      tableColumn: [
        { title: 'ID', key: 'id', width: 80, align: 'center' },
        { title: '操作人员', key: 'admin_name', width: 120, align: 'center' },
        { title: '操作类型', key: 'log_type_name', width: 180, align: 'center' },
        { title: '操作内容', key: 'operation_content', minWidth: 300, tooltip: true },
        { title: '请求URL', key: 'request_url', width: 200, align: 'center', tooltip: true },
        { title: 'IP地址', key: 'ip', width: 140, align: 'center' },
        { title: '操作时间', key: 'operation_time', width: 180, align: 'center' },
      ]
    };
  },
  methods: {
    timeChange(date) {
      if (date && date.length === 2) {
        this.searchData.startTime = date[0];
        this.searchData.endTime = date[1];
      } else {
        this.searchData.startTime = '';
        this.searchData.endTime = '';
      }
      this.$refs.table.getLists();
    },
    // 搜索：回到第一页并查询
    handleSearch() {
      this.$refs.table.searchAndResetPage();
    },
    // 重置：清空所有筛选条件后回到第一页查询
    handleReset() {
      this.searchData.operator = '';
      this.searchData.type = '';
      this.searchData.timeRange = [];
      this.searchData.startTime = '';
      this.searchData.endTime = '';
      this.$refs.table.searchAndResetPage();
    }
  }
};
</script>

<style scoped lang="less">
</style>
